/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Log_OutInputs */

const en_common_log_out = /** @type {(inputs: Common_Log_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log Out`)
};

const es_common_log_out = /** @type {(inputs: Common_Log_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

/**
* | output |
* | --- |
* | "Log Out" |
*
* @param {Common_Log_OutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_log_out = /** @type {((inputs?: Common_Log_OutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Log_OutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_log_out(inputs)
	return en_common_log_out(inputs)
});